import * as React from 'react';
import { Grid, Paper, Alert } from '@mui/material';

export default function ErrorView() {
  return (
    <React.Fragment>
      <Grid item xs={12}>
        <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
          <Alert severity="warning">
            There has been a problem!
          </Alert>   
        </Paper>
      </Grid>
    </React.Fragment>);
}